export default __webpack_public_path__ + "static/media/photo_5282747746622312917_y.1eda0b2e.jpg";